export default "__VITE_ASSET__BNTTjsTW__"